import { render, staticRenderFns } from "./ListAlbums.vue?vue&type=template&id=19ef6f8c&scoped=true&"
import script from "./ListAlbums.vue?vue&type=script&lang=js&"
export * from "./ListAlbums.vue?vue&type=script&lang=js&"
import style0 from "./ListAlbums.vue?vue&type=style&index=0&id=19ef6f8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ef6f8c",
  null
  
)

export default component.exports